
    import {computed, ComputedRef, defineComponent, watch, reactive} from 'vue'
    import {useRoute} from "vue-router"
    import {useStore} from "@/store";

    interface State {
        vin: string;
        carModel: string;
        carImg: string;
        reportLevel: number;
    }

    export default defineComponent({
        name: "carNameVin",
        setup() {
            let state: State = reactive({
                vin: '',
                carModel: '',
                carImg: '',
                reportLevel: 0
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {vin, modelName, photoList} = data;
                state.vin = vin;
                state.carModel = modelName;
                let carImgObj = photoList.filter(function(item: any){
                    return item.photoCode == "SP1"; 
                })
                state.carImg = carImgObj[0].photoPath;
            })
            return {
                state
            }
        }
    })
